import { getBaseUrl, getCurrentAccessToken, request } from './client.js';
import { ApiError } from './errors.js';
/**
 * Assign a user to a location.
 *
 * Returns `{ data, created }`:
 * - `created: true`  → HTTP 201, new assignment was created.
 * - `created: false` → HTTP 200, assignment already existed (idempotent re-assign).
 */
export async function assignUserToLocation(locationId, input) {
    const { body, status } = await _fetchWithStatus(`/admin/locations/${encodeURIComponent(locationId)}/assignments`, { method: 'POST', body: input });
    return { data: body, created: status === 201 };
}
export async function unassignUserFromLocation(locationId, userId) {
    return request(`/admin/locations/${encodeURIComponent(locationId)}/assignments/${encodeURIComponent(userId)}`, { method: 'DELETE' });
}
export async function listAssignedUsers(locationId, params) {
    const qs = new URLSearchParams();
    if (params?.page !== undefined)
        qs.set('page', String(params.page));
    if (params?.limit !== undefined)
        qs.set('limit', String(params.limit));
    const query = qs.toString() ? `?${qs.toString()}` : '';
    return request(`/admin/locations/${encodeURIComponent(locationId)}/assignments${query}`, { method: 'GET' });
}
export async function listLocationsForUser(userId) {
    return request(`/admin/users/${encodeURIComponent(userId)}/locations`, { method: 'GET' });
}
export async function getMyLocations() {
    return request('/me/locations', { method: 'GET' });
}
async function _fetchWithStatus(path, opts) {
    const token = getCurrentAccessToken();
    const headers = { 'content-type': 'application/json' };
    if (token)
        headers.authorization = `Bearer ${token}`;
    const init = {
        method: opts.method ?? 'POST',
        headers,
        credentials: 'include',
        signal: opts.signal,
    };
    if (opts.body !== undefined)
        init.body = JSON.stringify(opts.body);
    let res;
    try {
        res = await fetch(`${getBaseUrl()}${path}`, init);
    }
    catch (err) {
        throw new ApiError('network_error', err instanceof Error ? err.message : 'fetch failed');
    }
    let payload = null;
    try {
        payload = await res.json();
    }
    catch {
        payload = null;
    }
    if (!res.ok) {
        const serverCode = payload?.code;
        const code = serverCode ?? 'unknown';
        const message = payload?.message ?? `HTTP ${res.status}`;
        throw new ApiError(code, message, res.status, payload, serverCode === undefined);
    }
    return { status: res.status, body: payload };
}
//# sourceMappingURL=location-assignments.js.map